module.exports = __webpack_public_path__ + "static/media/dropdown.8aee23b3.svg";